import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {VehicleType} from "../../../commons/types/vehicle.type";
import {SplitService} from "../../../commons/services/split-service.service";
import {TaskModel} from "../../models/task.model";
import {IAMPermissionsService} from "../../../../permission/iamPermissions.service";

export class internalTaskItemCtrl implements IController {

  task: TaskModel;
  isSelected: boolean;
  isHighlighted: boolean;
  onTaskSelectToggle: Function;
  onEditBoundEquipment: Function;

  public bindingSubTask: any;
  public logisticsVehiclesRefList: any;
  private configZoneId: any;
  private purposeToServiceType: any;
  public enableAgentVehicleBinding: boolean;

  /* @ngInject */
  constructor(private $task, private tasksConstants,
              private IAMPermissions: IAMPermissionsService,
              private splitService: SplitService) {
  }

  $onInit() {
    this.configZoneId = this.splitService.getTimeZone();
    this.purposeToServiceType = this.tasksConstants.purposeToServiceType;

    if (this.task.subTasks && (this.task.taskSpec.purpose === 'StartRoute' || this.task.taskSpec.purpose === 'EndRoute')) {

      this.bindingSubTask = _.find(this.task.subTasks, (st) => {
        return _.find(st.actions, (ac) => {
          return ac.type === "VehicleBinding";
        })!!
      })

      this._setLogisticsVehiclesRefList(this.bindingSubTask);
    }

    this.enableAgentVehicleBinding = this.IAMPermissions.hasPermission('vehicleInstance.logisticsVehicle.update') &&
      !!this.splitService.getEnableAgentVehicleBinding();

  }

  onChangeStatus(task, status) {
    this.task = task;
  }

  private _setLogisticsVehiclesRefList(bindingSubTask) {
    this.logisticsVehiclesRefList = [];
    if (!!bindingSubTask) {
      _.forEach(bindingSubTask.actions, (ac) => {
        if (ac.type === "VehicleBinding") {
          const logisticsVehicleReference = _.get(ac, 'logisticsVehicleReference');
          _.get(logisticsVehicleReference, 'vehicleType') === VehicleType.Trailer ?
            this.logisticsVehiclesRefList.push(logisticsVehicleReference) : this.logisticsVehiclesRefList.unshift(logisticsVehicleReference)
        }
      })
    }
  }

}

angular
  .module('bringoz.admin.tasks')
  .component('internalTaskItem', {
    bindings: {
      task: '<',
      isSelected: '<',
      isHighlighted: '<',
      onTaskSelectToggle: '&',
      onEditBoundEquipment: '&',
    },
    templateUrl: ($element, $attrs) => {
      const templates = {
        'day': 'app/modules/tasks/components/internal-task-item/templates/internal-task-day-item.html',
        'route': 'app/modules/tasks/components/internal-task-item/templates/internal-task-route-item.html'
      };
      return templates[$attrs.template || 'day'];
    },
    controller: internalTaskItemCtrl
  });
